<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
            <div class="page-header-left pl-3 pt-5">
                <h3>Tài khoản: {{currentItem.Username}}</h3>
            </div>
            <v-layout row wrap justify-end>
              <v-flex class="lg3">
                <v-card>
                  <v-app-bar flat dense class="hpo_color">
                    <v-toolbar-title>
                        <h5>Tiền nạp</h5>
                    </v-toolbar-title>
                  </v-app-bar>
                  <v-card-text>
                      <h4>{{currentItem.TotalAmount | currency}}</h4>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex class="lg3">
                <v-card>
                  <v-app-bar flat dense class="hpo_color">
                    <v-toolbar-title>
                        <h5>Tiền hàng</h5>
                    </v-toolbar-title>
                  </v-app-bar>
                  <v-card-text>
                      <h4>{{currentItem.TotalPayment | currency}}</h4>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex class="lg3">
                <v-card>
                  <v-app-bar flat dense class="hpo_color">
                    <v-toolbar-title>
                        <h5>Dư ví</h5>
                    </v-toolbar-title>
                  </v-app-bar>
                  <v-card-text>
                      <h4>{{currentItem.Wallet | currency}}</h4>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex class="lg3">
                <v-card>
                  <v-app-bar flat dense class="hpo_color">
                    <v-toolbar-title>
                        <h5>Công nợ</h5>
                    </v-toolbar-title>
                  </v-app-bar>
                  <v-card-text>
                      <h4>{{currentItem.Debt | currency}}</h4>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12>
            <div class="page-header-left pl-3 pt-5">
                <h3>Đơn mua hộ</h3>
            </div>
            <v-data-table :headers="order_headers" :fixed-header="true" height="600px" :items="orders" :options.sync="order_pagination" :server-items-length="order_rows" :footer-props="items_per_page" :must-sort="true" :loading="order_loading" :mobile-breakpoint="100">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>{{ item.OrderCode }}</td>
                        <td>
                            {{ item.BoughtDate | display_date('DD-MM-YYYY')}}
                            <br />
                            {{ item.BoughtDate | display_date('HH:mm:ss')}}
                        </td>
                        <td>
                            <v-chip :color="get_order_status_color(item.Status)" label outlined small> {{ item.Status | order_status}}</v-chip>
                        </td>
                        <td>{{ item.OrderCodeCN }}</td>
                        <td>{{ item.TransactionCode }}</td>
                        <td class="text-end">{{ item.AmountVND | currency }}</td>
                        <td class="text-end">{{ item.FeeShipCNVND | currency }}</td>
                        <td class="text-end">{{ item.FeeBuyAmount | currency }}</td>
                        <td class="text-end">{{ item.FeeWeightAmount | currency }}</td>
                        <td class="text-end">{{ item.FragileFeeVND | currency }}</td>
                        <td class="text-end">{{ item.CheckFeeVND | currency }}</td>
                        <td class="text-end">{{ item.FastFeeVND | currency }}</td>
                        <td class="text-end">{{ item.FeeOther | currency }}</td>
                        <td class="text-end">{{ item.DiscountVND | currency }}</td>
                        <td class="text-end">{{ item.TotalAmountVND | currency }}</td>
                        <td class="text-end">{{ item.Deposit | currency }}</td>
                        <td class="text-end">{{ item.TotalAmountVND - item.Deposit | currency }}</td>
                    </tr>
                </template>
                <template v-slot:body.append>
                    <tr class="total-summary-td">
                        <td colspan="5" class="text-center font-weight-bold">Tổng</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.AmountVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.FeeShipCNVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.FeeBuyAmount | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.FeeWeightAmount | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.FragileFeeVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.CheckFeeVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.FastFeeVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.FeeOther | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.DiscountVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.TotalAmountVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.Deposit | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.Remain | currency }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex lg12>
            <div class="page-header-left pl-3 pt-5">
                <h3>Đơn ký gửi</h3>
            </div>
            <v-data-table :headers="deposit_headers" :fixed-header="true" height="600px" :items="deposits" :options.sync="deposit_pagination" :server-items-length="deposit_rows" :footer-props="items_per_page" :must-sort="true" :loading="deposit_loading" :mobile-breakpoint="100">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>{{ 'KG'+item.ID }}</td>
                        <td>
                            {{ item.CreatedDate | display_date('DD-MM-YYYY')}}
                            <br />
                            {{ item.CreatedDate | display_date('HH:mm:ss')}}
                        </td>
                        <td>
                            <v-chip :color="get_order_status_color(item.Status)" label outlined small> {{ item.Status | order_status}}</v-chip>
                        </td>
                        <td class="text-end">{{ item.FeeShipVND | currency }}</td>
                        <td class="text-end">{{ item.FeeWeight | currency }}</td>
                        <td class="text-end">{{ item.GuaranteeAmountVND | currency }}</td>
                        <td class="text-end">{{ item.FragileFeeVND | currency }}</td>
                        <td class="text-end">{{ item.CheckFeeVND | currency }}</td>
                        <td class="text-end">{{ item.FeeOther | currency }}</td>
                        <td class="text-end">{{ item.DiscountVND | currency }}</td>
                        <td class="text-end">{{ item.TotalPriceVND | currency }}</td>
                        <td class="text-end">{{ item.Payment | currency }}</td>
                        <td class="text-end">{{ item.TotalPriceVND - item.Payment | currency }}</td>
                    </tr>
                </template>
                <template v-slot:body.append>
                    <tr class="total-summary-td">
                        <td colspan="3" class="text-center font-weight-bold">Tổng</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.FeeShipVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.FeeWeight | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.GuaranteeAmountVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.FragileFeeVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.CheckFeeVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.FeeOther | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.DiscountVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.TotalPriceVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.Payment | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.Remain | currency }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex lg12>
            <div class="page-header-left pl-3 pt-5">
                <h3>Thanh toán hộ</h3>
            </div>
            <v-data-table :headers="payservice_headers" :fixed-header="true" height="600px" :items="payservices" :options.sync="payservice_pagination" :server-items-length="payservice_rows" :footer-props="items_per_page" :must-sort="true" :loading="payservice_loading" :mobile-breakpoint="100">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>{{ 'TT'+item.ID }}</td>
                        <td>
                            {{ item.CreatedDate | display_date('DD-MM-YYYY')}}
                            <br />
                            {{ item.CreatedDate | display_date('HH:mm:ss')}}
                        </td>
                        <td v-bind:style="{ 'color': get_status_color(item.Status, payservice_statuslist)}">{{ item.Status | display_value(payservice_statuslist) }}</td>
                        <td class="text-end">{{ item.AmountVND | currency }}</td>
                        <td class="text-end">{{ item.FeeAmount | currency }}</td>
                        <td class="text-end">{{ item.GuaranteeAmount | currency }}</td>
                        <td class="text-end">{{ item.TotalAmount | currency }}</td>
                        <td class="text-end">{{ item.Payment | currency }}</td>
                    </tr>
                </template>
                <template v-slot:body.append>
                    <tr class="total-summary-td">
                        <td colspan="3" class="text-center font-weight-bold">Tổng</td>
                        <td class="text-end font-weight-bold">{{ !payservices_summary ? 0 : payservices_summary.AmountVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !payservices_summary ? 0 : payservices_summary.FeeAmount | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !payservices_summary ? 0 : payservices_summary.GuaranteeAmount | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !payservices_summary ? 0 : payservices_summary.TotalAmount | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !payservices_summary ? 0 : payservices_summary.Payment | currency }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex lg12>
            <div class="page-header-left pl-3 pt-5">
                <h3>Lịch sử nạp tiền</h3>
            </div>
            <v-data-table :headers="recharge_headers" :fixed-header="true" height="600px" :items="recharges" :options.sync="recharge_pagination" :server-items-length="recharge_rows" :footer-props="items_per_page" :must-sort="true" :loading="recharge_loading" :mobile-breakpoint="100">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>
                            {{ item.CreatedDate | display_date('DD-MM-YYYY')}}
                            <br />
                            {{ item.CreatedDate | display_date('HH:mm:ss')}}
                        </td>
                        <td v-bind:style="{ 'color': get_status_color(item.Status, recharge_status_list)}">{{ item.Status | display_value(recharge_status_list) }}</td>
                        <td>{{ item.Method | display_value(recharge_methods) }}</td>
                        <td class="text-end">{{ item.Amount | currency }}</td>
                    </tr>
                </template>
                <template v-slot:body.append>
                    <tr class="total-summary-td">
                        <td colspan="3" class="text-center font-weight-bold">Tổng</td>
                        <td class="text-end font-weight-bold">{{ !recharge_summary ? 0 : recharge_summary.Amount | currency }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex lg12>
            <div class="page-header-left pl-3 pt-5">
                <h3>Lịch sử rút tiền</h3>
            </div>
            <v-data-table :headers="withdraw_headers" :fixed-header="true" height="600px" :items="withdraws" :options.sync="withdraw_pagination" :server-items-length="withdraw_rows" :footer-props="items_per_page" :must-sort="true" :loading="withdraw_loading" :mobile-breakpoint="100">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>
                            {{ item.CreatedDate | display_date('DD-MM-YYYY')}}
                            <br />
                            {{ item.CreatedDate | display_date('HH:mm:ss')}}
                        </td>
                        <td v-bind:style="{ 'color': get_status_color(item.Status, withdraw_status_list)}">{{ item.Status | display_value(withdraw_status_list) }}</td>
                        <td class="text-end">{{ item.Amount | currency }}</td>
                    </tr>
                </template>
                <template v-slot:body.append>
                    <tr class="total-summary-td">
                        <td colspan="2" class="text-center font-weight-bold">Tổng</td>
                        <td class="text-end font-weight-bold">{{ !withdraw_summary ? 0 : withdraw_summary.Amount | currency }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex lg12>
            <div class="page-header-left pl-3 pt-5">
                <h3>Lịch sử thanh toán</h3>
            </div>
            <v-data-table :headers="pay_headers" :fixed-header="true" height="600px" :items="pays" :options.sync="pay_pagination" :server-items-length="pay_rows" :footer-props="items_per_page" :must-sort="true" :loading="pay_loading" :mobile-breakpoint="100">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>
                            {{ item.CreatedDate | display_date('DD-MM-YYYY')}}
                            <br />
                            {{ item.CreatedDate | display_date('HH:mm:ss')}}
                        </td>
                        <td v-if="item.Status != payment_type_enum.PhiKhac" v-bind:style="{ 'color': get_status_color(item.Status, payment_type)}">{{ item.Status | display_value(payment_type) }}</td>
                        <td v-if="item.Status == payment_type_enum.PhiKhac">{{ item.FeeName }}</td>
                        <td class="text-end">{{ item.Amount | currency }}</td>
                    </tr>
                </template>
                <template v-slot:body.append>
                    <tr class="total-summary-td">
                        <td colspan="2" class="text-center font-weight-bold">Tổng</td>
                        <td class="text-end font-weight-bold">{{ !pay_summary ? 0 : pay_summary.Amount | currency }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex lg12>
            <div class="page-header-left pl-3 pt-5">
                <h3>Lịch sử khiếu nại</h3>
            </div>
            <v-data-table :headers="complain_headers" :fixed-header="true" height="600px" :items="complains" :options.sync="complain_pagination" :server-items-length="complain_rows" :footer-props="items_per_page" :must-sort="true" :loading="complain_loading" :mobile-breakpoint="100">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>
                            {{ item.CreatedDate | display_date('DD-MM-YYYY')}}
                            <br />
                            {{ item.CreatedDate | display_date('HH:mm:ss')}}
                        </td>
                        <td>Đã xử lý</td>
                        <td class="text-end">{{ item.Amount | currency }}</td>
                    </tr>
                </template>
                <template v-slot:body.append>
                    <tr class="total-summary-td">
                        <td colspan="2" class="text-center font-weight-bold">Tổng</td>
                        <td class="text-end font-weight-bold">{{ !complain_summary ? 0 : complain_summary.Amount | currency }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "../../configs";
import { request_list } from "@/commons/hpod";
import Vue from "vue";
import _ from "lodash";
import moment from "moment";
export default {
  data() {
    return {
      valid: true,
      payservice_statuslist: configs.PAY_SERVICE_STATUS,
      recharge_status_list: configs.RECHARGE_STATUS_LIST,
      recharge_methods: configs.RECHARGE_METHODS,
      withdraw_status_list: configs.WITHDRAW_STATUS_LIST,
      payment_type: configs.PAYMENT_STATUS_LIST,
      payment_type_enum: configs.PAYMENT_STATUS,
      order_headers: [
        {
          text: "Mã đơn",
          value: "ID"
        },
        {
          text: "Ngày mua",
          value: "BoughtDate"
        },
        {
          text: "Trạng thái",
          value: "Status"
        },
        {
          text: "Mã đơn CN",
          value: "OrderCodeCN"
        },
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          width: "50px"
        },
        {
          text: "Tiền hàng",
          value: "AmountVND",
          align: "end",
        },
        {
          text: "Ship nội địa",
          value: "FeeShipCNVND",
          align: "end",
        },
        {
          text: "Phí dịch vụ",
          value: "FeeBuyAmount",
          align: "end",
        },
        {
          text: "Phí vận chuyển",
          value: "FeeWeightAmount",
          align: "end",
        },
        {
          text: "Phí gia cố",
          value: "FragileFeeVND",
          align: "end",
        },
        {
          text: "Phí kiểm đếm",
          value: "CheckFeeVND",
          align: "end",
        },
        {
          text: "Phí hoả tốc",
          value: "FastFeeVND",
          align: "end",
        },
        {
          text: "Phí khác",
          value: "FeeOther",
          align: "end",
        },
        {
          text: "Chiết khấu",
          value: "DiscountVND",
          align: "end",
        },
        {
          text: "Tổng tiền",
          value: "TotalAmountVND",
          align: "end",
        },
        {
          text: "Đã trả",
          value: "Deposit",
          align: "end"
        },
        {
          text: "Còn thiếu",
          value: "",
          align: "end"
        }
      ],
      order_pagination: {
          ...configs.PAGINATION,
          sortBy: ["BoughtDate"]
      },
      deposit_headers: [
        {
          text: "Mã đơn",
          value: "ID"
        },
        {
          text: "Ngày đặt",
          value: "CreatedDate"
        },
        {
          text: "Trạng thái",
          value: "Status"
        },
        {
          text: "Ship nội địa",
          value: "FeeShipVND",
          align: "end",
        },
        {
          text: "Phí vận chuyển",
          value: "FeeWeight",
          align: "end",
        },
        {
          text: "Phí bảo hiểm",
          value: "GuaranteeAmountVND",
          align: "end",
        },
        {
          text: "Phí gia cố",
          value: "FragileFeeVND",
          align: "end",
        },
        {
          text: "Phí kiểm đếm",
          value: "CheckFeeVND",
          align: "end",
        },
        {
          text: "Phí khác",
          value: "FeeOther",
          align: "end",
        },
        {
          text: "Chiết khấu",
          value: "DiscountVND",
          align: "end",
        },
        {
          text: "Tổng tiền",
          value: "TotalPriceVND",
          align: "end",
        },
        {
          text: "Đã trả",
          value: "Payment",
          align: "end"
        },
        {
          text: "Còn thiếu",
          value: "",
          align: "end"
        }
      ],
      deposit_pagination: {
          ...configs.PAGINATION,
          sortBy: ["CreatedDate"]
      },
      payservice_headers: [
        {
          text: "Mã đơn",
          value: "ID"
        },
        {
          text: "Ngày đặt",
          value: "CreatedDate"
        },
        {
          text: "Trạng thái",
          value: "Status"
        },
        {
          text: "Tiền thanh toán",
          value: "AmountVND",
          align: "end",
        },
        {
          text: "Phí thanh toán",
          value: "FeeAmount",
          align: "end",
        },
         {
          text: "Phí bảo hiểm",
          value: "GuaranteeAmount",
          align: "end",
        },
        {
          text: "Tổng tiền",
          value: "TotalAmount",
          align: "end",
        },
        {
          text: "Đã trả",
          value: "Payment",
          align: "end"
        }
      ],
      payservice_pagination: {
          ...configs.PAGINATION,
          sortBy: ["CreatedDate"]
      },
      recharge_headers: [
        {
          text: "Ngày nạp",
          value: "CreatedDate"
        },
        {
          text: "Trạng thái",
          value: "Status"
        },
        {
          text: "Hình thức",
          value: "Method"
        },
        {
          text: "Số tiền",
          value: "TotalAmount",
          align: "end",
        }
      ],
      recharge_pagination: {
          ...configs.PAGINATION,
          sortBy: ["CreatedDate"]
      },
      withdraw_headers: [
        {
          text: "Ngày rút",
          value: "CreatedDate"
        },
        {
          text: "Trạng thái",
          value: "Status"
        },
        {
          text: "Số tiền",
          value: "TotalAmount",
          align: "end",
        }
      ],
      withdraw_pagination: {
          ...configs.PAGINATION,
          sortBy: ["CreatedDate"]
      },
      pay_headers: [
        {
          text: "Ngày thanh toán",
          value: "CreatedDate"
        },
        {
          text: "Loại phí",
          value: "FeeName"
        },
        {
          text: "Số tiền",
          value: "Amount",
          align: "end",
        }
      ],
      pay_pagination: {
          ...configs.PAGINATION,
          sortBy: ["CreatedDate"]
      },
      complain_headers: [
        {
          text: "Ngày khiếu nại",
          value: "CreatedDate"
        },
        {
          text: "Trạng thái",
          value: "Status"
        },
        {
          text: "Số tiền",
          value: "Amount",
          align: "end",
        }
      ],
      complain_pagination: {
          ...configs.PAGINATION,
          sortBy: ["CreatedDate"]
      },
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      filterConditions: [],
      quickFilterConditions: [],
      viewName: "bao-cao-cong-no-chi-tiet",
      summary: {}
    };
  },
  watch: {
    order_pagination: {
        handler: function (val, oldVal) {
            let filterConditions = this.$store.state.commons.filterConditions;
            this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
            this.order_filter_data();
        },
        deep: true
    },
    deposit_pagination: {
        handler: function (val, oldVal) {
            let filterConditions = this.$store.state.commons.filterConditions;
            this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
            this.deposit_filter_data();
        },
        deep: true
    },
    payservice_pagination: {
        handler: function (val, oldVal) {
            let filterConditions = this.$store.state.commons.filterConditions;
            this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
            this.payservice_filter_data();
        },
        deep: true
    },
    recharge_pagination: {
        handler: function (val, oldVal) {
            let filterConditions = this.$store.state.commons.filterConditions;
            this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
            this.recharge_filter_data();
        },
        deep: true
    },
    withdraw_pagination: {
        handler: function (val, oldVal) {
            let filterConditions = this.$store.state.commons.filterConditions;
            this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
            this.withdraw_filter_data();
        },
        deep: true
    },
    pay_pagination: {
        handler: function (val, oldVal) {
            let filterConditions = this.$store.state.commons.filterConditions;
            this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
            this.pay_filter_data();
        },
        deep: true
    },
    complain_pagination: {
        handler: function (val, oldVal) {
            let filterConditions = this.$store.state.commons.filterConditions;
            this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
            this.complain_filter_data();
        },
        deep: true
    },
  },
  computed: {
    ...mapState({
        currentItem: state => state.report.debtReportDetail,
        orders: state => state.main_order.all.data,
        order_summary: state => state.main_order.all.summary,
        order_rows: state => state.main_order.all.total,
        order_loading: state => state.main_order.loading,
        deposits: state => state.deposit.all.data,
        deposit_rows: state => state.deposit.all.total,
        deposit_loading: state => state.deposit.loading,
        deposit_summary: state => state.deposit.all.summary,
        payservices: state => state.payservice.all.data,
        payservices_summary: state => state.payservice.all.summary,
        payservice_rows: state => state.payservice.all.total,
        payservice_loading: state => state.payservice.loading,
        recharges: state => state.rechargeHistory.all.data,
        recharge_rows: state => state.rechargeHistory.all.total,
        recharge_summary: state => state.rechargeHistory.all.summary,
        recharge_loading: state => state.rechargeHistory.loading,
        withdraws: state => state.withDraw.all.data,
        withdraw_rows: state => state.withDraw.all.total,
        withdraw_summary: state => state.withDraw.all.summary,
        withdraw_loading: state => state.withDraw.loading,
        pays: state => state.paymentHistory.all.data,
        pay_rows: state => state.paymentHistory.all.total,
        pay_summary: state => state.paymentHistory.all.summary,
        pay_loading: state => state.paymentHistory.loading,
        complains: state => state.historypaywallet.all.data,
        complain_rows: state => state.historypaywallet.all.total,
        complain_summary: state => state.historypaywallet.all.summary,
        complain_loading: state => state.historypaywallet.loading,
    }),
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    uId() {
        return Number(this.$route.params.Pid);
    },
  },
  methods: {
    filter_data: function() {
        this.$store.dispatch("report/getDebtReportDetail", this.uId);
        this.order_filter_data();
        this.deposit_filter_data();
        this.payservice_filter_data();
        this.recharge_filter_data();
        this.withdraw_filter_data();
        this.pay_filter_data();
        this.complain_filter_data();
    },
    order_filter_data: function() {
      var param = {
        pagination: this.order_pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      param.filter = [
        {
            column: 'Status',
            value: [0,1,3],
            condition: 'not_in'
        },
        {
            column: 'UID',
            value: this.uId,
            condition: 'equal'
        }
      ]
      this.$store.dispatch("main_order/getListOrderDebts", param);
    },
    deposit_filter_data: function() {
      var param = {
        pagination: this.deposit_pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      param.filter = [
        {
            column: 'Status',
            value: 1,
            condition: 'does_not_equal'
        },
        {
            column: 'UID',
            value: this.uId,
            condition: 'equal'
        }
      ]
      this.$store.dispatch("deposit/getList", param);
    },
    payservice_filter_data: function() {
      var param = {
        pagination: this.payservice_pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      param.filter = [
        {
            column: 'Status',
            value: 5,
            condition: 'equal'
        },
        {
            column: 'UID',
            value: this.uId,
            condition: 'equal'
        }
      ]
      this.$store.dispatch("payservice/getList", param);
    },
    recharge_filter_data: function() {
      var param = {
        pagination: this.recharge_pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      param.filter = [
        {
            column: 'Status',
            value: 2,
            condition: 'equal'
        },
        {
            column: 'UID',
            value: this.uId,
            condition: 'equal'
        }
      ]
      this.$store.dispatch("rechargeHistory/getList", param);
    },
    withdraw_filter_data: function() {
      var param = {
        pagination: this.withdraw_pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      param.filter = [
        {
            column: 'Status',
            value: 2,
            condition: 'equal'
        },
        {
            column: 'UID',
            value: this.uId,
            condition: 'equal'
        }
      ]
      this.$store.dispatch("withDraw/getList", param);
    },
    pay_filter_data: function() {
      var param = {
        pagination: this.withdraw_pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      param.filter = [
        {
            column: 'Status',
            value: [10,11],
            condition: 'in'
        },
        {
            column: 'UID',
            value: this.uId,
            condition: 'equal'
        }
      ]
      this.$store.dispatch("paymentHistory/getPaymentHistoryList", param);
    },
    complain_filter_data: function() {
      var param = {
        pagination: this.withdraw_pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      param.filter = [
        {
            column: 'TradeType',
            value: 7,
            condition: 'equal'
        },
        {
            column: 'UID',
            value: this.uId,
            condition: 'equal'
        }
      ]
      this.$store.dispatch("historypaywallet/getList", param);
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    get_order_status_color(value){
      const objStatus = configs.ORDER_STATUS.find(obj => obj.value === value);
      return objStatus ? objStatus.color : 'black';
    }
  },
  mounted() {
    this.filter_data();
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>